import React, { Component } from "react";
import classNames from "classnames";
import propTypes from "prop-types";
import AmountInput from "ReactComponents/Shared/FormInputs/amount-input";
import DeliveryCostsModalButton from "ReactComponents/DeliveryCostsModalButton/delivery-costs-modal-button";

class ProductPickerRadioSelect extends Component {
    constructor(props) {
        super(props);
        this.clickHandler = this.clickHandler.bind(this);
    }

    clickHandler(e, index) {
        e.preventDefault();
        const event = e;
        event.target.value = index;
        this.props.onChange(event);
    }

    render() {
        const currentSalesConfig = this.props.salesConfigIndex || 0;

        return (
            <div className="product-picker__items">
                {this.props.Work.Products.map((product, index) => {
                    const isCurrent = this.props.Work.Products[this.props.current].Id == product.Id;
                    const productConfig = product.PriceConfigurations[currentSalesConfig];
                    return (
                        <ProductComponent
                            key={index}
                            index={index}
                            isCurrent={isCurrent}
                            product={product}
                            productConfig={productConfig}
                            setAmount={this.props.setAmount}
                            amount={this.props.amount}
                            clickHandler={this.clickHandler}
                            productDeliveryInfo={this.props.Work.ProductDeliveryInfo}
                        />
                    );
                })}
            </div>
        );
    }
}

const ProductComponent = ({
    index,
    isCurrent,
    product,
    productConfig,
    setAmount,
    amount,
    clickHandler,
    productDeliveryInfo
}) => {
    const classList = classNames("product-picker__item", {
        selected: isCurrent,
        "radio__indicator--selected": isCurrent,
        "product-picker__item--selected": isCurrent
    });
    const priceClasses = classNames("product-picker__item__price", {
        discounted: product.DiscountedPrice
    });
    const hasPriceConfiguration = product.PriceConfigurations.length > 0;
    const hasProductInfoTextButNoPriceConfiguration = product.ProductInfoText && !hasPriceConfiguration;

    if (hasPriceConfiguration) {
        amount = amount ?? productConfig.Quantity;
    }

    return (
        <>
            <div key={index} className={classList}>
                <a
                    className="product-picker__item__link"
                    href={product.ProductPageLink}
                    onClick={e => {
                        e.preventDefault();
                        if (!isCurrent) {
                            clickHandler(e, index);
                        }
                    }}
                >
                    <div className="product-picker__item__radiowrap">
                        <span className="radio__indicator"></span>
                    </div>

                    <div className="product-picker__item__link__content">
                        <p className="product-picker--primary-text">{product.MediaType}</p>
                        {hasPriceConfiguration && (
                            <div className={priceClasses}>
                                <div>
                                    <span className="product-picker__unit-text">
                                        {product.StockText ? (
                                            <span className="price-label__stock">{product.StockText}</span>
                                        ) : (
                                            <span>{product.PriceUnit}</span>
                                        )}
                                        {" - "}
                                    </span>
                                    <span className="product-picker__item__price-primary product-picker--primary-text">
                                        {product.PrimaryPrice}
                                    </span>
                                    {product.DiscountedPrice && (
                                        <span className="product-picker__item__price-discount">
                                            {product.DiscountedPrice}
                                        </span>
                                    )}
                                </div>
                                <span className="product-picker__note">{product.SecondaryPrice}</span>
                                {product.IsPhysical && productDeliveryInfo && (
                                    <DeliveryCostsModalButton productDeliveryInfo={productDeliveryInfo} />
                                )}
                                {isCurrent && productConfig.IsBuyable && productConfig.AllowQuantity && (
                                    <div className="product-picker_quantitywrap">
                                        <AmountInput
                                            context={product.Title}
                                            onChange={e => {
                                                setAmount(e.target.value);
                                            }}
                                            min="1"
                                            value={amount}
                                        />
                                    </div>
                                )}
                            </div>
                        )}
                    </div>
                </a>
            </div>
            {isCurrent && hasProductInfoTextButNoPriceConfiguration && (
                <div className="product-picker-selected-details">
                    <div className="product-picker__item__info__row">
                        <div className="product-picker__item__product-info-text">
                            <div dangerouslySetInnerHTML={{ __html: product.ProductInfoText }} />
                        </div>
                    </div>
                </div>
            )}
        </>
    );
};

ProductPickerRadioSelect.propTypes = {
    Work: propTypes.object.isRequired
};

export default ProductPickerRadioSelect;
